// extracted by css-extract-rspack-plugin
export default {"openEnded":"dZpAn6mynKgEevjx","questionText":"eb78t5n4cagQxbs1"};